export const isEmpty = (value: string) => {
    return !value || value.length < 1;
};

export const serializeToJsonIncludingUndefined = (data: any, space?: string | number) =>
    JSON.stringify(data, (_, value) => (value == undefined ? null : value), space);

export const toTitleCase = (str: string) =>
    str
        .replace(/([A-Z])/g, " $1") // Add a space before capital letters
        .replace(/^./, match => match.toUpperCase()) // Capitalize the first letter
        .trim(); // Remove any leading/trailing spaces
